<template>
  <a-popconfirm
    v-if="is_update"
    :title="title"
    :ok-text="ok"
    :cancel-text="no"
    @visibleChange="visibleChange"
    @confirm="confirm"
    @cancel="cancel"
  >
    <a-button
      style="padding-left: 1px; width: 100%"
      type="link"
      :title="column.content ? column.content(record, text) : text"
    >
      <span
        v-if="column.content"
        style="
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 100%;
          user-select: text;
        "
      >
        <setting-outlined style="margin-right: 2px; color: #999" />
        <copy-outlined
          v-if="text.up_customer_id && !text.customer_id"
          title="复制"
          style="margin-right: 2px"
          @click.stop="copy_up()"
        />
        <span @click.stop="goto()">{{ column.content(record, text) }}</span>
      </span>
      <span
        v-else
        style="
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 100%;
          user-select: text;
        "
      >
        <setting-outlined style="margin-right: 2px; color: #999" />
        <copy-outlined
          v-if="text.up_customer_id && !text.customer_id"
          title="复制"
          style="margin-right: 2px"
          @click.stop="copy_up()"
        />
        <span @click.stop="goto()">{{ text }}</span>
      </span>
    </a-button>
  </a-popconfirm>
  <a-button
    v-else
    style="padding-left: 1px; width: 100%"
    type="link"
    :title="column.content ? column.content(record, text) : text"
  >
    <span
      v-if="column.content"
      style="
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 100%;
        user-select: text;
      "
    >
      <span @click.stop="goto()">{{ column.content(record, text) }}</span>
    </span>
    <span
      v-else
      style="
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 100%;
        user-select: text;
      "
    >
      <span @click.stop="goto()">{{ text }}</span>
    </span>
  </a-button>
</template>

<script lang="ts">
import { defineComponent, ref, reactive, createVNode } from 'vue';
import modalBox from '@/components/form-modal/modal-tools';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import { config } from '@/components/page-model/mjstore/mjstore-area-config';
import bus from '@/utils/bus';
import { create_appointment, update_appointment, delete_appointment } from '@/api/mjstore-model';
import { message, Modal } from 'ant-design-vue';
import { ExclamationCircleOutlined, SettingOutlined, CopyOutlined } from '@ant-design/icons-vue';
import router from '@/router';
export default defineComponent({
  name: 'Cell_click_order',
  props: {
    column: {
      type: Object,
      required: true,
      default: () => {},
    },
    is_update: {
      type: Boolean,
      required: true,
      default: () => false,
    },
    index: {
      type: Number,
      required: true,
    },
    text: {
      type: [String, Number, Object],
      required: true,
    },
    record: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  setup(props: any) {
    const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
    const event_bus = bus;
    const title: any = ref('');
    const ok: any = ref('');
    const no: any = ref('');
    const visibleChange = () => {
      if (!props.text.appointment_id) {
        title.value = props.record.time + ' ' + props.column.title;
        ok.value = '新增预约';
        no.value = '取消';
      } else {
        title.value = props.text.customer__name + '-' + props.text.project__name;
        ok.value = '修改';
        no.value = '删除';
      }
    };
    const confirm = () => {
      if (!props.text.appointment_id) {
        let time_list: any = props.record.time.split('-');
        const editModal = reactive({
          visible: true,
          title: '新建预约',
          loading: false,
          form: {
            settings: {
              labelAlign: 'right',
              layout: 'horizontal',
              col: config.creatCol,
              labelCol: {
                span: 7,
              },
              wrapperCol: {
                span: 17,
              },
            },
            fields: [
              {
                type: 'remotemodal',
                name: 'customer_id',
                label: '会员姓名',
                disabled: false,
                placeholder: '请选择会员姓名',
                datasourceType: 'remote',
                mode: 'default',
                allowClear: true,
                modalType: 'mjstore-customer',
              },
              {
                type: 'remotemodal',
                name: 'project_id',
                label: '项目名称',
                disabled: false,
                placeholder: '请选择项目名称',
                datasourceType: 'remote',
                mode: 'default',
                allowClear: true,
                modalType: 'mjstore-project',
              },
              // {
              //   type: 'input',
              //   name: 'note',
              //   label: '预约号',
              //   disabled: true,
              //   allowClear: true,
              //   inputType: 'text',
              //   defaultValue: '',
              //   placeholder: '请填写预约号',
              // },
              {
                type: 'remoteselect',
                name: 'shop_id',
                label: '预约门店',
                disabled: true,
                placeholder: '请选择预约门店',
                datasourceType: 'remote',
                mode: 'default',
                allowClear: true,
                modalType: 'mjstore-shop',
              },
              {
                type: 'remoteselect',
                name: 'staff_id',
                label: '预约治疗师/医生',
                disabled: true,
                placeholder: '请选择预约治疗师',
                datasourceType: 'remote',
                mode: 'default',
                allowClear: true,
                modalType: 'mjstore-staff',
              },
            ],
            rules: {
              customer_id: [{ required: true, message: '请填预约会员姓名' }],
              project_id: [{ required: true, message: '请填预约客项目' }],
              shop_id: [{ required: true, message: '请填预约门店' }],
              staff_id: [{ required: true, message: '请填预约治疗师' }],
            },
            model: reactive({
              org_id: current_org?.id,
              is_active: true,
              customer_id: null,
              project_id: null,
              note: null,
              shop_id: props.column.shop_id,
              staff_id: props.column.id,
            }),
          },
          options: {},
          ok: (payload: any) => {
            return new Promise(resolve => {
              editModal.loading = true;
              create_appointment({
                ...payload,
                start_datetime: props.column.date + ' ' + time_list[0] + ':00',
                end_datetime: props.column.date + ' ' + time_list[1] + ':00',
              })
                .then(() => {
                  message.success('新建预约成功');
                  event_bus.emit('refresh_order');
                  resolve(null);
                })
                .finally(() => {
                  editModal.loading = false;
                });
            });
          },
        });
        modalBox(editModal);
      } else {
        const editModal = reactive({
          visible: true,
          title: '修改预约',
          loading: false,
          form: {
            settings: {
              labelAlign: 'right',
              layout: 'horizontal',
              col: config.creatCol,
              labelCol: {
                span: 7,
              },
              wrapperCol: {
                span: 17,
              },
            },
            fields: [
              {
                type: 'remotemodal',
                name: 'customer_id',
                label: '会员姓名',
                disabled: false,
                placeholder: '请选择会员姓名',
                datasourceType: 'remote',
                mode: 'default',
                allowClear: true,
                modalType: 'mjstore-customer',
              },
              {
                type: 'remotemodal',
                name: 'project_id',
                label: '项目名称',
                disabled: false,
                placeholder: '请选择项目名称',
                datasourceType: 'remote',
                mode: 'default',
                allowClear: true,
                modalType: 'mjstore-project',
              },
              {
                type: 'input',
                name: 'note',
                label: '预约号',
                disabled: true,
                allowClear: true,
                inputType: 'text',
                defaultValue: '',
                placeholder: '请填写预约号',
              },
              {
                type: 'remoteselect',
                name: 'shop_id',
                label: '预约门店',
                disabled: true,
                placeholder: '请选择预约门店',
                datasourceType: 'remote',
                mode: 'default',
                allowClear: true,
                modalType: 'mjstore-shop',
              },
              {
                type: 'remoteselect',
                name: 'staff_id',
                label: '预约治疗师/医生',
                disabled: true,
                placeholder: '请选择预约治疗师',
                datasourceType: 'remote',
                mode: 'default',
                allowClear: true,
                modalType: 'mjstore-staff',
              },
            ],
            rules: {},
            model: reactive({
              org_id: current_org?.id,
              appointment_id: props.text.appointment_id,
              customer_id: props.text.customer_id,
              project_id: props.text.project_id,
              note: props.text.note,
              shop_id: props.column.shop_id,
              staff_id: props.column.id,
            }),
          },
          options: {},
          ok: (payload: any) => {
            return new Promise(resolve => {
              editModal.loading = true;
              update_appointment({
                ...payload,
              })
                .then(() => {
                  message.success('修改成功');
                  event_bus.emit('refresh_order');
                  resolve(null);
                })
                .finally(() => {
                  editModal.loading = false;
                });
            });
          },
        });
        modalBox(editModal);
      }
    };
    const copy_up = () => {
      let time_list: any = props.record.time.split('-');
      create_appointment({
        org_id: current_org?.id,
        customer_id: props.text.up_customer_id,
        project_id: props.text.up_project_id,
        note: null,
        shop_id: props.column.shop_id,
        staff_id: props.column.id,
        start_datetime: props.column.date + ' ' + time_list[0] + ':00',
        end_datetime: props.column.date + ' ' + time_list[1] + ':00',
      }).then(() => {
        message.success('复制新建预约成功');
        event_bus.emit('refresh_order');
      });
    };
    const goto = () => {
      router.push({
        path:
          '/business_manage/profile/basic/' +
          props.text.customer_id +
          '/' +
          props.text.customer__name,
      });
    };
    const cancel = () => {
      if (props.text.appointment_id) {
        Modal.confirm({
          title: '确认删除' + props.text.customer__name + '-' + props.text.project__name + '?',
          icon: createVNode(ExclamationCircleOutlined),
          onOk() {
            return new Promise(resolve => {
              delete_appointment({
                org_id: current_org.id,
                appointment_id: props.text.appointment_id,
              }).then(() => {
                message.success('删除成功');
                event_bus.emit('refresh_order');
                resolve(null);
              });
            }).catch(() => console.log('Oops errors!'));
          },
          onCancel() {},
        });
      }
    };
    return {
      title,
      ok,
      no,
      cancel,
      goto,
      copy_up,
      confirm,
      visibleChange,
    };
  },
  components: {
    SettingOutlined,
    CopyOutlined,
  },
});
</script>
